<template>
    <div id="page_data"  class="hidden">
   <section class="page-title jumbotron" id="infants" ref="page_data">
    <div class="auto-container">
       <div class="inner-container clearfix">
          <ul class="bread-crumb clearfix">
            <li><a href="/">Home</a></li>
            <li><a href="/curriculum/">Programs</a></li>
             <li class="editabledata">{{pageData.name}} Program</li>
          </ul>
          <h1 class="editabledata">{{pageData.name}}</h1>
       </div>
    </div>
    <div class="blog-object1 d-none d-xl-block skrollable skrollable-between" data-0="opacity:1;" data-100="transform:translatey(0%);" data-1025="transform:translatey(-80%);" style="opacity: 1; transform: translateY(0%);">
       <!-- Image -->
      <span class="d-block icon icon icon-pencil"></span>
    </div>
    <div class="blog-object2 d-none d-xl-block skrollable skrollable-between" data-0="opacity:1;" data-100="transform:translatey(0%);" data-1025="transform:translatey(-80%);" style="opacity: 1; transform: translateY(0%);">
     <!-- Image -->
      <span class="d-block icon icon-idea"></span>
   </div>
 </section>
 <!--End Page Title-->
 <!-- svg divider -->
 <svg id="main-divider" class="d-none d-xl-block" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none" viewBox="0 0 1920 120">
   <path fill-rule="evenodd" fill="#fff" d="M0,55.9621684 C300.495844,106.578393 620.495844,106.578393 960,55.9621684 C1299.50416,5.34594386 1619.50416,5.34594386 1920,55.9621684 L1920,120 L0,120 L0,55.9621684 Z"></path>
 </svg>
 <!-- Section -->
 <section class="pages">
    <div class="container">
       <div class="row">
          <!-- main wrapper -->
          <div class="main col-lg-9">
             <h2 class="editabledata">{{pageData.name}}</h2>
             <h4 class="editabledata">{{pageData.name}}</h4>
             <img src="https://dev3.barqsol.com/basic/images/infants.jpg" class="mt-1 col-md-5 float-right p-2 img-fluid rounded"/>
              <p class="editabledata">Infants need relationships and security above all else. Our goal is to develop a loving, trusting relationship, so your child feels secure, and confident that his/her needs will be met. We recognize that each child is unique, so we allow your child to tell us when it is time to eat, sleep, play, or just cuddle. We provide appropriate materials to stimulate and challenge your baby, with the knowledge that infants learn through moving their bodies, and experiencing with all their senses. We pay careful attention to caregiving routines as an opportunity for one-to-one interaction and conversation. Your infant will learn and grow rapidly this first year, and we will provide appropriate activities and challenges along the way to help them move into that wonderful toddler age!
                  </p>
                  <!-- buttons -->
                  <div class="mt-3">
                     <a href="/enrollment/index.phtml" class="btn btn-md theme-btn btn-style-one">Enrollment Info</a>
                     <a href="/contact/schedule-tour.phtml" class="btn btn-md  theme-btn btn-style-four">Schedule a Tour</a>
                  </div>
                  <!-- /buttons -->
                  <h3 class="mt-5 editabledata">Food for Infants and Crawlers</h3>
                  <p class="editabledata">Parents are responsible for providing formula, breast milk and baby food that are labeled with child’s name on it. Infants will be fed on demand and will be held while bottle feeding. For nursing mothers Advantage Early Learning Center provides a clean and private Nursing Room located in the infant rooms.
                  </p>

                  <h3 class="editabledata">What to Bring</h3>
                  <p class="editabledata">Parents of infants and toddlers should bring diapers, wipes, and any ointment or lotion they may use. They should also have at least two changes of clothing. We will do our best to protect your child’s clothing but there may be times when clothing may get stained.
                  </p>
                  <p class="editabledata">PLEASE DO NOT SEND YOUR CHILD IN CLOTHING THAT YOU DO NOT WANT GETTING DIRTY.</p>

                  <h3 class="editabledata">Daily Schedule</h3>
                  <p class="editabledata">Infants are growing and adapting at rapid rates so our staff is guided to be flexible and assess each child individually. While each day involves motor skills enhancement, brainpower exercises, arts and crafts, nap times, eating, physical activity, and music, each child’s schedule will be modified based on their unique needs. Our day is action-packed with learning lessons combined with feeding time, naptime, circle time, and floor play. The day includes outside time (weather permitting). Inside, children are exposed to group activities (i.e. storytime, songs, games) and personal one-on-one interaction (i.e. puzzles, independent play, tummy time practice).
                  </p>
          </div>
          <!-- /col-lg-9 -->
          <!-- sidebar programs include -->
                         <!-- Sidebar Column -->
   <div class="sidebar col-lg-3 h-50 pink-bg ">

<!-- Sidebar heading -->
 <h4>Programs</h4>
   <ul class="sidebar-ul">
                <li> <a href="/curriculum/infants.phtml">Infants</a></li>
                <li> <a href="/curriculum/toddlers.phtml">Toddlers</a></li>
                <li> <a href="/curriculum/preschool.phtml">PreSchool</a></li>
                <li> <a href="/curriculum/school.phtml">School Age</a></li>
                <li> <a href="/curriculum/summer.phtml">Summer Camp</a></li>
                <li> <a href="/curriculum/index.phtml">All Programs</a></li>
   </ul>
   </div>
       </div>
       <!-- /row -->
    </div>
    <!-- /container-->
 </section>
    </div>
</template>
<script>
import {
  program_temp,
} from "./ProgramTemplate";

export default {
    data() {
        return{
          main:program_temp,
        }
    },
    watch:{
      isSidebarActive(val){
          if(val){
               console.log(this.pageData)
               let doc = new DOMParser().parseFromString(this.main, "text/html");
               var d1 = doc.getElementById("sb-addsection");
               var parent = d1.parentNode
              //  d1.replaceWith(this.$refs.page_data);
               parent.insertBefore(this.$refs.page_data,d1)
               console.log(doc.documentElement.outerHTML)
               this.$emit('setProgramTemplate',doc.documentElement.outerHTML)
               
          }
      }
    },
    props: {
    isSidebarActive: {
      type: Boolean,
    },
    pageData: {
      type: Object,
    }
  },
}
</script>
